export default "__VITE_ASSET__Cjx5eyvA__"